import ImpersonationBanner from "@/components/layout/components/ImpersonationBanner";
import { RoundedIconButton } from "@/components/ui/rounded-icon-button";
import { ArrowLeft } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface CardHeaderProps {
  projectName: string;
  storeName: string;
  onBack: () => void;
}

export const CardHeader = memo(
  ({ projectName, storeName, onBack }: CardHeaderProps) => {
    const { t } = useTranslation();

    return (
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-4 pb-4 border-b">
          <div className="min-w-0 flex-1">
            <h1 className="text-lg font-semibold text-gray-900 truncate">
              {t("contractorCards.title.single")}
            </h1>
            <p className="text-gray-600 text-sm truncate">
              {projectName} - {storeName}
            </p>
            <ImpersonationBanner onlyIcon />
          </div>
          <RoundedIconButton variant="outline" size="sm" onClick={onBack}>
            <ArrowLeft />
            <span className="sr-only">{t("common.back")}</span>
          </RoundedIconButton>
        </div>
      </div>
    );
  },
);
